import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-order.reducer';

export const WorkOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workOrderEntity = useAppSelector(state => state.workOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workOrderDetailsHeading">
          <Translate contentKey="crawlerBackendApp.workOrder.detail.title">WorkOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{workOrderEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="crawlerBackendApp.workOrder.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {workOrderEntity.startDate ? (
              <TextFormat value={workOrderEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.workOrder.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {workOrderEntity.endDate ? (
              <TextFormat value={workOrderEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="workStatus">
              <Translate contentKey="crawlerBackendApp.workOrder.workStatus">Work Status</Translate>
            </span>
          </dt>
          <dd>{workOrderEntity.workStatus}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.workOrder.description">Description</Translate>
            </span>
          </dt>
          <dd>{workOrderEntity.description}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.workOrder.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {workOrderEntity.createdTimestamp ? (
              <TextFormat value={workOrderEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.workOrder.serviceOrder">Service Order</Translate>
          </dt>
          <dd>{workOrderEntity.serviceOrder ? workOrderEntity.serviceOrder.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.workOrder.owner">Owner</Translate>
          </dt>
          <dd>{workOrderEntity.owner ? workOrderEntity.owner.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-order/${workOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkOrderDetail;
